import React from 'react';

/**
 * Catches chunk load failures from React.lazy so a failed dynamic import
 * degrades gracefully instead of crashing the parent tree.
 *
 * Error Boundaries must be class components per React's design — this is a
 * legitimate exception to the no-class-components rule.
 */
// eslint-disable-next-line @repo/internal/react/no-class-components
export class ChunkErrorBoundary extends React.Component<
	{ children: React.ReactNode },
	{ hasError: boolean }
> {
	state: { hasError: boolean } = { hasError: false };

	static getDerivedStateFromError(): { hasError: boolean } {
		return { hasError: true };
	}

	componentDidCatch(error: Error): void {
		// Log chunk load failures so they are detectable in production
		// eslint-disable-next-line no-console
		console.error('[ChunkErrorBoundary] Failed to load async component chunk:', error);
	}

	render(): React.ReactNode {
		if (this.state.hasError) {
			return null;
		}
		return this.props.children;
	}
}
